import { Config } from "../config/Config";

export const Routes = {
    Home: Config?.url + '/',
    Login: Config?.url + '/login',
    Register: Config?.url + '/register',
    // Dashboard: Config?.url + '/dashboard',
    Profile: Config?.url + '/profile',
    ProfileDetail: Config?.url + '/complete-profile',


    TermsAndConditions: Config?.url + '/terms-and-conditions',
    PrivacyPolicy: Config?.url + '/privacy-policy',
    Faq: Config?.url + '/faq',
    About: Config?.url + '/about-us',
    CancellationPolicy: Config?.url + '/cancellation-policy',

    /* Dashboard pages */
    Dashboard: Config?.url + "/dashboard",
    ContactSupport: Config?.url + "/contact-support",
    ServiceManagement: Config?.url + "/service-management",
    AddService: Config?.url + '/service',
    ServiceUpdate: Config?.url + "/service-update/:id",
    ServiceManagementView: Config?.url + "/service-management/view/:id",


    AddNewServiceData: Config?.url + '/add-new-service',
    salonAvalibility: Config?.url + "/salon-availability",
    StaffMember: Config?.url + "/staff-member",
    StaffMemberDetails: Config?.url + "/staff-member/view/:id",
    StaffMemberUpdate: Config?.url + "/staff-member/update/:id",



    MyProfile: Config?.url + "/my-profile",





    MyBookings: Config?.url + "/my-bookings/:id/:month",
    MyBookingsDetails: Config?.url + "/my-bookings-details/:id/:booking-id/:service-id",
    OfflineBooking: Config?.url + "/offline-booking",


    /* for app */
    PrivacyAndPolicyAPP: Config?.url + "/app/privacy-policy",
    TermsAndConditionsAPP: Config?.url + '/app/terms-and-conditions',
    AboutAPP: Config?.url + '/app/about-us',
    CancellationAPP: Config?.url + '/app/cancellation-policy',

    ChangePassword: Config?.url + '/change-password',
    FAQPage: Config?.url + '/faqs',
    AppFAQPage: Config?.url + '/app/faqs',



    BillingManagement: Config?.url + '/billing',
    StaffAvailability: Config?.url + '/staff-availability',
    BillingManagementView: Config?.url + '/billing-management-view/:id/:service_id',
    Notification: Config?.url + '/notifications',
    SalesGrowthManagement: Config?.url + '/sales-growth-management',

    SubscriptionPlans: Config?.url + '/subscription-plans',
    SubscriptionPurchase: Config?.url + '/subscription-purchase',

}
